import { Injectable } from '@angular/core';
import { setOptions, importLibrary } from '@googlemaps/js-api-loader';
import { Capacitor } from '@capacitor/core';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class GoogleMapsLoaderService {
  private loadPromise: Promise<void> | null = null;

  constructor() {
    const apiKey =
      Capacitor.getPlatform() !== 'web'
        ? environment.apiKeyMapAndroid
        : environment.apiKeyMapWeb;

    setOptions({ key: apiKey });
  }

  load(): Promise<void> {
    if (!this.loadPromise) {
      this.loadPromise = Promise.all([
        importLibrary('maps'),
        importLibrary('places'),
      ])
        .then(() => undefined)
        .catch((error) => {
          this.loadPromise = null;
          throw error;
        });
    }
    return this.loadPromise;
  }
}
